import { BookingPaidCalendar } from 'client/components/entities/booking-paid-calendar'
import { TwoStepPaymentForm as TwoStepPaymentFormNew } from 'client/components/entities/two-step-payment-form/two-step-payment-form'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { OfferPriceInterface } from 'common/types/entities/OfferPriceInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { OrderBumpInterface } from 'common/types/entities/order-bump-interface'
import { TwoStepPaymentFormInterface } from 'common/types/entities/two-step-payment-form-interface'
import React from 'react'
import createCommonEntityElement, {
  AdditionalProps,
} from '../createCommonEntityElement'
import OfferPriceNew from './entities/OfferPrice'
import OrderBump from './entities/order-bump'

export default function createEntityElementForOffer(
  entity: EntityInterface | OldEntityInterface,
  additionalProps: AdditionalProps,
) {
  switch (entity.type) {
    case EntityTypeEnum.OfferPrice:
      return (
        <OfferPriceNew
          key={`entity-${entity.id}`}
          entity={entity as OfferPriceInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.OrderBump:
      return (
        <OrderBump
          key={`entity-${entity.id}`}
          entity={entity as OrderBumpInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BookingPaidCalendar:
      return (
        <BookingPaidCalendar
          entity={entity as BookingPaidCalendarInterface}
          key={`entity-${entity.id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.TwoStepPaymentForm:
      return (
        <TwoStepPaymentFormNew
          entity={entity as TwoStepPaymentFormInterface}
          key={`entity-${entity.id}`}
          {...additionalProps}
        />
      )
    default:
      return createCommonEntityElement(entity, additionalProps)
  }
}
